export default "__VITE_ASSET__9b0a3d90__"